import React from 'react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

export function StatCard({ title, value, icon: Icon, trend, trendUp, className }) {
  return (
    <Card className={cn('bg-white border-gray-200 hover:border-gray-300 shadow-sm transition-colors', className)}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">
              {title}
            </p>
            <p className="font-heading text-3xl font-bold text-gray-900">
              {value}
            </p>
            {trend !== undefined && (
              <p className={cn(
                'text-xs font-medium mt-1',
                trendUp ? 'text-emerald-500' : 'text-rose-500'
              )}>
                {trendUp ? '↑' : '↓'} {trend}%
              </p>
            )}
          </div>
          {Icon && (
            <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">
              <Icon className="w-5 h-5 text-gray-500" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
